import hcOffcanvasNav from "hc-offcanvas-nav";

/**
 * More configurations can be found at https://github.com/somewebmedia/hc-offcanvas-nav
 * @param {string} menuContainerCssClass - The CSS class of the menu container
 * @param {string} toggleBtnCssClass - The CSS class of the toggle button
 */
export default function mobileMenu(menuContainerCssClass, toggleBtnCssClass) {
	let logo;
	if (customLogo) {
		logo = document.createElement('img');
		logo.src = customLogo;
		logo.alt = 'Logo Bissardon';
		logo.width = 150;
		logo.height = 100;
		logo.classList.add('mobile-menu-logo');
	}
	new hcOffcanvasNav(menuContainerCssClass, {
		navTitle: logo ? logo : 'Accueil',
		disableAt: 1024,
		customToggle: toggleBtnCssClass,
		position: 'left',
		bodyInsert: 'append',
		labelBack: 'Retour',
		//levelTitleAsBack: true,
		ariaLabels: {
			open: 'Ouvrir le menu',
			close: 'Fermer le menu',
			submenu: 'Sous-menu'
		}
	});
}